<template>
    <div class="nodata-container">
        <img
            class="nodata-icon"
            src="@/assets/icons/svg/nodata.svg"
            alt="nodata"
        >
        <div class="nodata-content">
            {{ $t(text) }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import {useI18n} from 'vue-i18n';
const i18n = useI18n();
const props = defineProps({
    text: {
        type: String,
        default: 'formInfo.noData'
    }
});
</script>

<style lang="scss" scoped>
.nodata-container {
    width: 100%;
    height: 100%;
    display: flex;
    padding-top: 40px;
    padding-bottom: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    .nodata-icon {
        width: 128px;
    }
    .nodata-content {
        color: #606266;
        font-family: PingFang SC;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
}
</style>
